import { Card as BaseCard } from 'antd';
import styled from 'styled-components';

export const Card = styled(BaseCard)`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgb(225, 235, 254);
  box-shadow: rgb(214, 221, 239) 0px 2px 4px 0px;
`;
